import { frontendURL } from '../../../../helper/URLHelper';

const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/bad-words'),
      component: SettingsContent,
      props: {
        headerTitle: 'BAD_WORDS.HEADER',
        icon: 'warning',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'settings_bad_words',
          roles: ['administrator'],
          component: Index,
        },
      ],
    },
  ],
};
